import localStorage from './localStorage'

// A gift code someone opened before signing in: kept in this browser so that, once they
// sign in or create an account, Morsel takes them back to it
const KEY = 'MORSEL_PENDING_GIFT'

export const rememberGiftCode = (code) => {
  try {
    if (code) localStorage.setItem(KEY, String(code))
  } catch (e) {
    // private browsing: they can still open the link again
  }
}

export const pendingGiftCode = () => {
  try {
    const code = localStorage.getItem(KEY)
    return code ? String(code) : ''
  } catch (e) {
    return ''
  }
}

export const forgetGiftCode = () => {
  try {
    localStorage.removeItem(KEY)
  } catch (e) {
    // nothing to forget
  }
}
